import { combineReducers } from 'redux';
const defaultBoxes = [];
export const favoriteBoxes = (state = defaultBoxes, action) => {
  switch (action.type) {
    case 'FAVORITE_BOXES_SUCCESS':
      return action.favoriteBoxes;
    default:
      return state;
  }
};

const favBoxes = [];
export const getSetFavBoxes = (state = favBoxes, action) => {
  switch (action.type) {
    case 'GET_SET_FAVORITE':
      return action.boxes;
    default:
      return state;
  }
};
